import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextMaskModule } from 'angular2-text-mask';

import { DynamicTranslationModule } from '../dynamic-translation/dynamic-translation.module';
import { SharedModule } from '../shared.module';

import { InputGridComponent } from './input-grid/input-grid.component';
import { IpAddressComponent } from './ip-address/ip-address/ip-address.component';
import { NumberComponent } from './number/number.component';
import { LsSingleSelectModule } from './select/single/ls-single-select/ls-single-select.module';
import { TextAreaComponent } from './text-area/text-area/text-area.component';
import { TextComponent } from './text/text.component';
import { SpinnerLoaderComponent } from './loader/spinner-loader/spinner-loader.component';
import { TimeFormComponent } from './time/time-form.component';

@NgModule({
  imports: [
    DynamicTranslationModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TextMaskModule,
    SharedModule,
    LsSingleSelectModule
  ],
  declarations: [
    IpAddressComponent,
    TextAreaComponent,
    TextComponent,
    NumberComponent,
    InputGridComponent,
    SpinnerLoaderComponent,
    TimeFormComponent
  ],
  exports: [
    IpAddressComponent,
    TextAreaComponent,
    TextComponent,
    NumberComponent,
    InputGridComponent,
    SpinnerLoaderComponent,
    TimeFormComponent
  ]
})
export class ComponentsModule {}
